import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  toggleFields() {
    const name = this.element.value

    document.getElementById('resolver_casasoft_fields').classList.toggle('hidden', name !== 'casasoft')
    document.getElementById('resolver_account_field').classList.toggle('hidden', name !== 'casasoft' && name !== 'inforce_alianca')
    document.getElementById('resolver_account_label').textContent = name === 'inforce_alianca' ? 'Conta (X-Client-Account)' : 'Empresa (CasaSoft)'
  }
}
